import React, { useRef } from "react";
import ImageUploadPlaceholder from "../../../img/image_upload_placeholder.svg";
import UploadIcon from "../../../img/upload_pink.svg";

const UserImageUpload = ({ image, onImageChange, disabled }) => {
  const fileInputRef = useRef(null);
  const isImageObject = image && typeof image === "object" && image.url;
  const imageUrl = isImageObject
    ? image.url
    : image
      ? URL.createObjectURL(image)
      : null;

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      onImageChange(file);
    }
  };

  const handleUploadClick = () => {
    if (fileInputRef.current && !disabled) {
      fileInputRef.current.click();
    }
  };

  return (
    <div className="user-image-upload">
      <img
        src={imageUrl ? imageUrl : ImageUploadPlaceholder}
        alt="Profile"
        className="profile-image-preview"
      />
      <label htmlFor="image-upload" className="image-upload-label">
        Add Profile Photo
      </label>
      <span className="image-upload-hint">
        Upload a clear photo in PNG, JPG or JPEG format <br />
        (maximum 1 MB).
      </span>
      <input
        ref={fileInputRef}
        id="image-upload"
        name="image"
        type="file"
        accept="image/*"
        onChange={handleFileChange}
        disabled={disabled}
        className="user-image-input hidden-file-input"
      />
      <button
        type="button"
        className="image-upload-btn"
        onClick={handleUploadClick}
        disabled={disabled}
      >
        <img src={UploadIcon} alt="Upload" className="upload-icon" />
        Upload
      </button>
    </div>
  );
};

export default UserImageUpload;
